export const state = {
    core: [], // core->user
    user_id: -1, //this id will be set
    client_id: -1,
    user_role: -1,
    permissions: [],
    username: "",
    coreLoadingStatus: null,
    menu: null,

    //types of users
    loggedIn_user_role: "team_manager",
    loggedIn_user_id: "1", // 1 - admin; 3 - guy cosnulting
    // loggedIn_user_role: "team_member",
    // loggedIn_user_role: "client",
};

export const getDefaultState = () => {
    return {
        core: [],
        user_id: -1,
        client_id: -1,
        permissions: [],
        username: "",
        menu: null,
        //
        loggedIn_user_role: null,
        loggedIn_user_id: null,
    };
};

export const getters = {
    getUserId(state) {
        return state.user_id;
    },
    getClientId(state) {
        return state.client_id;
    },
    // !NB this for the dashbaord; where should the user be redirected on first load
    getValidUserRoute(state, getters) {
        if (state.user_role == "Certificate Team" && getters.findPermission(6)) {
            return "/clients";
        }
        if (state.user_role == "Certificate Team") {
            return "/collectionslist";
        }
        if (state.user_role == "User") {
            return "/suppliers/" + state.client_id;
        }

        return "error";
    },
    //eslint-disable-next-line
    findPermission: (state) => (name) => {
        //search for permission
        let findId = state.permissions.find((findId) => findId.name == name);
        //tpye cast to true or false if the the permission is undefined i.e. none existant
        return typeof findId !== "undefined";
    },
    isTypeUser(state) {
        if (state.user_role == "User") {
            return true;
        }

        return false;
    },
};

export const actions = {
    loadCoreData({ commit }) {
        commit("setCoreLoadingStatus", false);
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/core")
                .then((response) => {
                    commit("setCoreData", response.data);
                    commit("setCoreLoadingStatus", true);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    handleLogout({ commit }) {
        return new Promise((resolve) => {
            commit("resetState");
            resolve();
        });
    },
    // eslint-disable-next-line
    saveAddTeamMember({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/admin/addteammember", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    // eslint-disable-next-line
    saveEditTeamMember({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/admin/editteammember", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    // eslint-disable-next-line
    deleteTeamMember({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/admin/deleteteammember", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
};

export const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setCoreLoadingStatus(state, payload) {
        state.coreLoadingStatus = payload;
    },
    setCoreData(state, payload) {
        //eslint-disable-next-line
        state.core = payload;
        state.user_id = payload.user.id;
        state.client_id = payload.user.client.client_id;
        //state.client_id = payload.
        state.user_role = payload.role.name;
        state.permissions = payload.permissions;

        state.username = payload.user.username;

        /**
         * Section for generating the menu
         */

        //eslint-disable-next-line
        let menuArray = [];
        //eslint-disable-next-line
        const permissions = state.permissions;

        //eslint-disable-next-line
        function searchForPermission(permissions, name) {
            //search for permission
            let findId = permissions.find((findId) => findId.name == name);
            //tpye cast to true or false if the the permission is undefined i.e. none existant
            return typeof findId !== "undefined";
        }

        if (state.user_role == "User") {
            menuArray.push(
                {
                    id: 1,
                    label: "Menu",
                    isTitle: true,
                },
                {
                    id: 2,
                    label: "Suppliers",
                    icon: "bx-group",
                    link: `/suppliers/${state.client_id}`, // ! might need to change to client_id
                }
            );
            //return the User Menu
            state.menu = menuArray;
        }

        // if (state.user_role == "Certificate Team") {
        //     // The User Can view the clients
        //     if (searchForPermission(permissions, 6)) {
        //         menuArray.push({
        //             id: 1,
        //             label: "Collections",
        //             icon: "bx-collection",
        //             istitle: true,
        //             subItems: [
        //                 {
        //                     id: 10001,
        //                     label: "Clients",
        //                     link: "/clients",
        //                     parentId: 1,
        //                 },
        //                 {
        //                     id: 10002,
        //                     label: "Collections list",
        //                     link: "/collectionslist",
        //                     parentId: 1,
        //                 },
        //                 {
        //                     id: 10003,
        //                     label: "Client suppliers",
        //                     link: "/collectionslist/client",
        //                     parentId: 1,
        //                 },
        //             ],
        //         });
        //     } else {
        //         menuArray.push({
        //             id: 1,
        //             label: "Collections",
        //             icon: "bx-collection",

        //             subItems: [
        //                 {
        //                     id: 10002,
        //                     label: "Collections list",
        //                     link: "/collectionslist",
        //                     parentId: 1,
        //                 },
        //                 {
        //                     id: 10003,
        //                     label: "Client suppliers",
        //                     link: "/collectionslist/client",
        //                     parentId: 1,
        //                 },
        //             ],
        //         });
        //     }

        //     if (searchForPermission(permissions, 6)) {
        //         menuArray.push({
        //             id: 2,
        //             label: "Vetting",
        //             icon: "bx-check-shield",
        //             istitle: true,
        //             subItems: [
        //                 {
        //                     id: 20001,
        //                     label: "Certificate Authentication",
        //                     link: "/certificate-authentication",
        //                     parentId: 2,
        //                 },
        //                 {
        //                     id: 20002,
        //                     label: "Authentication History",
        //                     link: "/authentication-history",
        //                     parentId: 1,
        //                 },
        //             ],
        //         });
        //     }

        //     if (searchForPermission(permissions, 6)) {
        //         menuArray.push({
        //             id: 3,
        //             label: "Validation",
        //             icon: "bx-calendar-check",
        //             istitle: true,

        //             subItems: [
        //                 {
        //                     id: 30001,
        //                     label: "Validation & Checks",
        //                     link: "/validation-and-checks",
        //                     parentId: 3,
        //                 },
        //                 {
        //                     id: 30001,
        //                     label: "User Administration",
        //                     link: "/user-administration",
        //                     parentId: 3,
        //                 },
        //             ],
        //         });
        //     }
        // }

        let collections = { id: 1, label: "Collections", icon: "bx-collection", istitle: true, subItems: [] };

        if (state.user_role == "Certificate Team") {
            //collections
            if (
                searchForPermission(permissions, "Add and Remove Collection Clients") ||
                searchForPermission(permissions, "Add and Remove Collection Clients") ||
                searchForPermission(permissions, "Assign and Remove Team Members for Collections") ||
                searchForPermission(permissions, "Add and Edit Suppliers") ||
                searchForPermission(permissions, "Delete Suppliers")
            ) {
                //clients
                if (searchForPermission(permissions, "Add and Remove Collection Clients")) {
                    collections.subItems.push({
                        id: 10001,
                        label: "Clients",
                        link: "/clients",
                        parentId: 1,
                    });
                }
                //colelctionlist
                if (
                    searchForPermission(permissions, "Add and Remove Collection Clients") ||
                    searchForPermission(permissions, "Assign and Remove Team Members for Collections")
                ) {
                    collections.subItems.push({
                        id: 10002,
                        label: "Collections list",
                        link: "/collectionslist",
                        parentId: 1,
                    });
                }

                //suppliers
                if (searchForPermission(permissions, "Add and Edit Suppliers") || searchForPermission(permissions, "Delete Suppliers")) {
                    collections.subItems.push({
                        id: 10003,
                        label: "Client suppliers",
                        link: "/collectionslist/client",
                        parentId: 1,
                    });
                }

                menuArray.push(collections);
            }

            let vetting = {
                id: 2,
                label: "Vetting",
                icon: "bx-check-shield",
                istitle: true,
                subItems: [],
            };

            //vetting
            if (searchForPermission(permissions, "Send Certificates to Agency")) {
                //cert authentication
                if (searchForPermission(permissions, "Send Certificates to Agency")) {
                    vetting.subItems.push({
                        id: 20001,
                        label: "Certificate Authentication",
                        link: "/certificate-authentication",
                        parentId: 2,
                    });
                }
                //Auth Hisotry
                if (searchForPermission(permissions, "Send Certificates to Agency")) {
                    vetting.subItems.push({
                        id: 20002,
                        label: "Authentication History",
                        link: "/authentication-history",
                        parentId: 1,
                    });
                }

                menuArray.push(vetting);
            }

            let validation = {
                id: 3,
                label: "Validation",
                icon: "bx-calendar-check",
                istitle: true,

                subItems: [],
            };

            //validatiion
            if (searchForPermission(permissions, "Validation and Checks") || searchForPermission(permissions, "Add, Edit and Delete Team Members")) {
                //validation and checks
                if (searchForPermission(permissions, "Validation and Checks")) {
                    validation.subItems.push({
                        id: 30001,
                        label: "Validation & Checks",
                        link: "/validation-and-checks",
                        parentId: 3,
                    });
                }

                if (searchForPermission(permissions, "Add, Edit and Delete Team Members")) {
                    validation.subItems.push({
                        id: 30001,
                        label: "User Administration",
                        link: "/user-administration",
                        parentId: 3,
                    });
                }

                menuArray.push(validation);
            }
        }

        state.menu = menuArray;
    },
};
